<template>
  <div class="index">

    <div class="toOrgTeam" v-if ="ischange" @click = "toServerslist">
      <img src="../../../assets/images/pageHome/toMore.png" alt="" />
    </div>
    <div class="leftabe">
      <div :class="[ischange ? 'taber' : 'active']" @click="change">
        <img src="../../../assets/images/pageHome/hua.png" class="tImg" alt />
        <div class="taText">服务质量</div>
      </div>
      <div :class="[ischange ? 'active' : 'taber']" @click="change">
        <img src="../../../assets/images/pageHome/fankuio.png" class="tImg1" alt />
        <div class="taText1">意见建议</div>
      </div>
    </div>
    <div class="rightabe" v-if="ischange">
      <div
        class="changeList"
        v-if="ischange"
        style="margin-top: 8px; margin-left: 16px"
      >
        <div :class="[isc ? 'changer' : 'cactive']" @click="toweek1">本周</div>
        <div class="block"></div>
        <div :class="[isc1 ? 'changer' : 'cactive']" @click="toweek2">本月</div>
      </div>
      <div
        v-for="(item, index) in list"
        style="height: 11.2%; line-height: 11.2%"
        :key="index"
        @click="toProjectList(823)"
      >
      <!-- @click="toProjectList(item.id)" -->
      <!-- =========================================== -->
        <!-- <div
          :class="{ lister: true, wranBg: item.evalutaion < 3 ? true : false }"
          v-if="ischange"
          :style="{
            border: index == 0 ? 'none' : 'border-top: 1px solid RGBA(12, 33, 52, 1);',
          }"
        > -->
        <!-- ========================================== -->
        <div
          :class="{ lister: true, wranBg: item.num < 3 ? true : false }"
          v-if="ischange"
          :style="{
            border: index == 0 ? 'none' : 'border-top: 1px solid RGBA(12, 33, 52, 1);',
          }"
        >
          <!-- {{ item.actName.length > 20 ? item.actName.slice(0,20)+'...' : item.actName }} -->
          {{item.text}}

          <!-- ======================== -->
          <!-- <div :class="[item.evalutaion > 0 ? 'listerImg1': '','listerImg']">
            <div class="nums" v-if="item.evalutaion > 0">
              {{ item.evalutaion }} 
            </div>   
          </div> -->
          <!-- ============================= -->
          <div :class="[item.num > 0 ? 'listerImg1': '','listerImg']">
            <div class="nums" v-if="item.num > 0">
              {{ item.num }}          
            </div>
          </div>


          <!-- =============================== -->
          <!-- <img
            class="warn"
            v-if="item.evalutaion > 0 && item.evalutaion < 3 ? true : false"
            src="../../../assets/images/warn.png"
            alt
          /> -->
          <!-- ================================= -->
          <img
            class="warn"
            v-if="item.num > 0 && item.num < 3 ? true : false"
            src="../../../assets/images/warn.png"
            alt
          />

        </div>
      </div>
    </div>
    <div class="rightabe" v-if="!ischange">
      <div
        v-for="(item, index) in messList"
        :key="index"
        style="height: 11.2%; line-height: 11.2%"
      >
        <div
          class="listerz"
          v-if="!ischange"
          :style="{
            border: index == 0 ? 'none' : 'border-top: 1px solid RGBA(12, 33, 52, 1);',
          }"
        >
          <div>
            {{ item.text }}
          </div>

          <div style="display: flex; align-items: center">
            {{ item.num }}
            <img
              class="thumb"
              style="margin-left: 11px"
              src="../../../assets/images/thumb.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      list:[],
      timeType:1,
      isc: true,
      isc1: false,
      messList: [
        { text: "给当前社会公益慈善组织的三个建议", num: "432" },
        {
          text: "社会公益慈善组织的存在其意义不仅仅停留在社会贡献上",
          num: "210",
        },
        { text: "探索创设公益慈善实体，实现自养发展", num: "89" },
        { text: "建立义工“存单”制度", num: "321" },
        { text: "给当前社会公益慈善组织的三个建议", num: "432" },
        {
          text: "社会公益慈善组织的存在其意义不仅仅停留在社会贡献上",
          num: "210",
        },
        { text: "探索创设公益慈善实体，实现自养发展", num: "89" },
        { text: "建立义工“存单”制度 ", num: "321" },
      ],
      weekList: [
        {
          text: "“我们的节日·重阳节”凯旋街道喜迎新时代 欢度重阳",
          num: "4.5",
          istar: true,
        },
        {
          text: "“亚运进社区”正念舒压课程  ",
          num: "3.5",
          istar: true,
        },
        {
          text: "“给爸妈洗一次澡，修一次脚”老年人关爱",
          num: "1.5",
          istar: true,
        },
        {
          text: "情暖千家 快乐共享 ",
          num: "4.8",
          istar: false,
        },
        {
          text: "“幸福乐居”助老伴我行",
          num: "3",
          istar: false,
        },
        {
          text: "“暑期周周乐”青少年成长营 ",
          num: " 4.1",
          istar: false,
        },
        {
          text: "崇军优属关爱服务",
          num: "2.8",
          istar: true,
        },
        {
          text: "“枢纽型社会组织培育提升",
          num: "4.7",
          istar: false,
        },
      ],
      weekList1: [
        {
          text: "“我们的节日·重阳节”凯旋街道喜迎新时代 欢度重阳",
          num: "4.5",
          istar: true,
        },
        {
          text: "“亚运进社区”正念舒压课程  ",
          num: "3.5",
          istar: true,
        },
        {
          text: "“给爸妈洗一次澡，修一次脚”老年人关爱",
          num: "1.5",
          istar: true,
        },
        {
          text: "情暖千家 快乐共享 ",
          num: "4.8",
          istar: false,
        },
        {
          text: "“幸福乐居”助老伴我行",
          num: "3.3",
          istar: false,
        },
        {
          text: "“暑期周周乐”青少年成长营 ",
          num: " 4.1",
          istar: false,
        },
        {
          text: "崇军优属关爱服务",
          num: "2.8",
          istar: true,
        },
        {
          text: "“枢纽型社会组织培育提升",
          num: "4.7",
          istar: false,
        },
      ],
      monthList: [
        {
          text: "崇军优属关爱服务",
          num: "2.8",
          istar: true,
        },
        {
          text: "枢纽型社会组织培育提升",
          num: "4.7",
          istar: false,
        },
        {
          text: "“幸福乐居”助老伴我行",
          num: "3.3",
          istar: false,
        },
        {
          text: "“给爸妈洗一次澡，修一次脚”老年人关爱",
          num: "1.5",
          istar: true,
        },
        {
          text: "情暖千家 快乐共享",
          num: "4.8",
          istar: false,
        },
        {
          text: "“暑期周周乐”青少年成长营",
          num: "4.1",
          istar: false,
        },
        {
          text: "“我们的节日·重阳节”凯旋街道喜迎新时代 欢度重阳",
          num: "4.5",
          istar: true,
        },
        {
          text: "“亚运进社区”正念舒压课程",
          num: "3.5",
          istar: true,
        },
      ],
      options: [
        {
          value: "选项1",
          label: "本周",
        },
        {
          value: "选项2",
          label: "本月",
        },
        {
          value: "选项3",
          label: "本年",
        },
      ],
      value: "",
      ischange: true,
    };
  },
   created() {
    // this.getList();  // 有数据时
    this.toweek1();        // 无数据时
  },
  methods: {
    //  项目情况
    toProjectList(id) {
      // demandDetails?id=823
      this.$router.push({
        path: "/demandDetails",
        query: { id },
      });
    },
    toServerslist(){
        this.$router.push('/servers');
    },
    change() {
      this.ischange = !this.ischange;
      console.log(this.messList, "messList");
    },
    // 本周
    toweek1() {
      this.isc = true;
      this.isc1 = false;
      this.list = this.weekList
      //有数据时
      // this.timeType = 1
      // this.getList()

    },
    // 本月
    toweek2() {
       this.isc1 = true;
       this.isc = false
       this.list = this.monthList

      // 有数据时
      // this.timeType = 2
      //  this.getList()
    },

     // 获取列表
    getList () {
      let url =
        this.$baseUrl + "/teamword/wechat/kyyProject/selectKyyActivityPageList";
      let postData = {
        // page: this.page,
        limit: 8,
        timeType:this.timeType,    // 1本周   2本月
        // street: this.id,
        // projectServiceType: this.select1,
        // projectCategory: this.select2,
      };
      this.postRequest(url, postData)
        .then((res) => {
          // this.list = res.data.list;
          // this.total = res.data.total;
          this.list = res.data.list
          console.log('res',res.data.list)
          // this.text = res.data.list.actName;
          // this.num = res.data.list.evalutaion;
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" scoped>
.changeList {
  transform: translateX(-3px) translateY(3px);
  width: 83px;
  height: 31px;
  line-height: 31px;
  background: url("../../../assets/images/pageHome/mountBg.png") no-repeat center/100% 100%;
  border-radius: none;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  text-align: center;
  padding-left: 10px;
  display: flex;
  flex-direction: row;
  .block {
    width: 1px;
    height: 11px;
    background: #fff;
    margin: 0 11px;
    margin-top: 11px;
  }
  .cactive {
    height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #C2DCF0;
  }
  img {
    width: 11px;
    height: 7px;
    margin-left: 8px;
    margin-top: 12px;
  }
}
.star {
  width: 13px;
  height: 13px;
  margin-bottom: 2px;
}
.index {
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 20px;
  cursor: pointer;
  // margin-top:px;
  .toOrgTeam {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    width: 350px;
    height: 40px;
    top: 0.5%;
    right: -16.2px;
    z-index: 1000;
    cursor: pointer;
    z-index: 10000;
    // background: pink;
    img {
      display: inline-block;
      width: 50px;
      height: 14px;
      z-index: 1000;
      margin-right: 42px;
      margin-top: 2px;
    }
  }
  .tImg {
    width: 21px;
    height: 20px;
    margin: 8px 12px 6px 12px;
  }
  .tImg1 {
    width: 17px;
    height: 13px;
    margin: 12px 12px 6px 13px;
  }
  .lister {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    // width: 411px;
    padding-left: 2%;
    width: 94.5%;
    height: 100%;
    // opacity: 0.32;
    margin-left: 15px;
    overflow: hidden;
    // line-height: 100%;
    align-items: center;

    border-top: 1px solid RGBA(12, 33, 52, 1);
    position: relative;
  }
  .wranBg {
    background: url("../../../assets/images/pageHome/warnBg.png") no-repeat
      center/100% 100%;
  }
  .listerz {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    width: 95%;
    height: 100%;
    // width: 448px;
    // opacity: 0.32;
    margin-left: 15px;
    overflow: hidden;
    border-top: 1px solid RGBA(12, 33, 52, 1);
    margin-top: 4px;
  }
  .nums {
    // line-height: 17px;
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;
    transform: translateY(1px) translateX(-8px);
  }
  .listerImg1{
    background: url("../../../assets/images/pageHome/startBg.png") no-repeat
      center/100% 100%;
  }
  .listerImg {
    
    width: 60px;
    height: 21px;
    margin: 0 5px;
    margin-bottom: 5px;
    // margin-top: 6px;
    
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .warn {
    width: 23px;
    height: 22px;
    // margin-top: 6px;
  }
  .taber {
    letter-spacing: 2px;
    width: 45px;
    height: 115px;
    background: #1177C1;
    border: 1px solid RGBA(12, 33, 52, 1);
    // opacity: 0.77;
    border-radius: 14px 0px 0px 14px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
  }
  .active {
    width: 45px;
    height: 115px;
    border: 1px solid RGBA(12, 33, 52, 1);
    border-radius: 14px 0px 0px 14px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    border-right: none;
  }
  .taText {
    letter-spacing: 3px;
    writing-mode: vertical-rl;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin: 0 auto;
    transform: translateY(-4px);
  }
  .taText1 {
    letter-spacing: 2.5px;
    writing-mode: vertical-rl;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    text-align: center;
    margin: 0 auto;
    transform: translateY(-3px);
  }
  .rightabe {
    // background: url(../../../assets/images/backbang.png)no-repeat
    //   center/100% 100%;;;
    // transform: translateY(-10px);
    width: 100%;
    height: 92%;
    border: 1px solid RGBA(12, 33, 52, 1);
    overflow: hidden;
  }
  .thumb {
    width: 17px;
    height: 17px;
  }
}
</style>
